import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import BtnPrimary from "../../../common/element/Buttons/btnPrimary";
import Card from "../../../common/element/Card";
import Heading from "../../../common/element/Heading";
import Circle from "../../../common/element/Iconcircle";
import { Link, useNavigate } from "react-router-dom";
import Validations from "../../../common/404/Validations";
import ThreeDotLoader from "../../../common/element/ButtonLoader/ThreeDotLoader";
import SweetAlertService from "../../../common/SweetAlert/SweetAlert";
import { forgotPassword, clearForgotPassword } from "../../../redux/auth/authSlice";

function ForgotPassword(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  // Get forgot password state from Redux
  const { loading, data, error } = useSelector((state) => state.auth.forgotPassword);
console.log("ForgotPassword - Redux State:", { loading, data, error });
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setEmailError("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate Email
    const emailValidation = Validations({
      value: email,
      Validations: { required: true, email: true },
    });
    
    if (!emailValidation.valid) {
      setEmailError(emailValidation.error_msg);
      return;
    }

    // Dispatch forgot password action - pass email string directly
    dispatch(forgotPassword(email));
  };

  // Handle success/error with SweetAlert
useEffect(() => {
  if (data && data.success) {
    SweetAlertService.showSuccess({
      title: 'Success!',
      message: 'Password reset link has been sent to your email.',
      subtitle: 'Check your inbox',
      confirmButtonText: 'OK',
      onConfirm: () => {
        // ✅ Delay navigation slightly to ensure SweetAlert closes first
        setTimeout(() => {
          localStorage.setItem("login", JSON.stringify(email));
          navigate("/check-email");
          dispatch(clearForgotPassword());
        }, 300);
      }
    });
  }

  if (error) {
    SweetAlertService.showError({
      title: 'Error!',
      message: error || 'Failed to send reset email. Please try again.',
      confirmButtonText: 'OK',
      onConfirm: () => {
        dispatch(clearForgotPassword());
      }
    });
  }
}, [data, error]); // ✅ Keep only necessary deps


  return (
    <div
      style={{ backgroundColor: `rgb(255, 244, 229)` }}
      className="flex justify-center min-h-screen"
    >
      <div className="min-h-screen justify-center flex py-12 px-6">
        <div className="flex-col items-center justify-center flex">
          <Card className="w-500 rounded-xl block-shadow w-100 mt-2 px-10 py-8">
            <Circle className="bg-blue-100 border-blue-50 mb-6">
              <img src="/assets/icons-svg/key.svg" alt="conserve" />
            </Circle>
            <h4 className="font-lato font-semibold text-[30px] leading-[38px] text-[#101828] text-wrap lg:text-nowrap text-center">Forgot password?</h4>
            <p className="font-lato font-medium text-base leading-[1.5] text-center text-[#475467] mb-[28px]">
              No worries, we'll send you reset instructions.
            </p>
            <div className="w-full">
              <form onSubmit={(e) => handleSubmit(e)}>
                <div className="mb-6">
                  <label className="block mb-[10px] font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] text-start">
                    Email address
                  </label>
                  <input
                    className="input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="email"
                    type="email"
                    value={email}
                    placeholder="Enter your email"
                    onChange={(e) => handleEmailChange(e)}
                    required
                    disabled={loading}
                  />
                  {emailError && (
                    <div className="text-red-500 text-sm mt-1">
                      {emailError}
                    </div>
                  )}
                </div>

                <div className="flex items-center justify-between w-100">
                  <BtnPrimary disabled={loading} type="submit">
                    {loading ? <ThreeDotLoader /> : "Reset password"}
                  </BtnPrimary>
                </div>
              </form>
            </div>
          </Card>
          <div className="mt-8 px-10 w-full text-center">
            <Link
              to="/login"
              className="text-xs text-gray-600 font-semibold hover:text-gray-900 focus:text-gray-600 flex justify-center items-center"
            >
              <img
                src="/assets/icons-svg/arrow-left.svg"
                className="w-5 mr-2"
                alt=""
              />
              Back to log in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;